
























import { OWebPageBase, OWebRouteContext } from "oweb";
import app from "@/app";
import BaseComponent from "@/components/BaseComponent.vue";
import { Component } from "vue-property-decorator";

@Component
export default class PAccount extends BaseComponent {
	loading: boolean = false;

	get user() {
		return app.user.getCurrentUser();
	}
	get mainComponent() {
		return app.store.route!.slug;
	}
}
